/**
 * External LearnX platforms — separate sites that sit outside this SPA but are
 * part of the same product. They run against the SAME Firebase project
 * (`learnxspaces`), so the account an admin provisions here signs in there
 * unchanged and the student↔mentor pairing they read is the live one from
 * `students`/`enrollments` — nothing is copied or synced (see
 * SANDBOX_INTEGRATION.md).
 *
 * Single source of truth for the hosts and the promo copy: the sidebar rail
 * (`layouts/components/navConfig`) and the dashboard tiles (`PlatformCard`)
 * both read from here, so changing a host is a one-line edit.
 *
 * Plain, serializable config — icons are referenced by string key and resolved
 * by the renderer, the same convention navConfig uses.
 */
export const EXTERNAL_PLATFORMS = Object.freeze({
  /** Mentor-assigned homework + a private exercise workspace. */
  sandbox: {
    key: 'sandbox',
    label: 'Sandbox',
    url: 'https://sandbox.learnxcode.com/',
    title: 'Sandbox',
    cta: 'Open sandbox',
    navIcon: 'code',
    badge: 'New',
    description: {
      student: 'Work through the exercises your mentor assigned and submit them for review.',
      mentor: 'Assign homework, then review and grade what your students submit.',
    },
  },
  /** Interactive simulation platform. */
  simulation: {
    key: 'simulation',
    label: 'Simulation',
    url: 'https://sim.learnxcode.com/',
    title: 'Simulation platform',
    cta: 'Open simulation',
    navIcon: 'flask',
    badge: null,
    description: {
      student: 'Practice with hands-on interactive simulations on our dedicated platform.',
      mentor: 'Run interactive simulations with your students on our dedicated platform.',
    },
  },
});

export const SANDBOX_URL = EXTERNAL_PLATFORMS.sandbox.url;
export const SIMULATION_URL = EXTERNAL_PLATFORMS.simulation.url;
